import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';


import {ErrorService, EventService} from '..';
import { ProjectResponse, PlayerResponse, Player, Session, Label, SessionResponse, AddLabelRequest,
  PlayerProfileSearchReq } from '../../core/models/';
import { ConfigService } from './config.service';
import { Accusation, AccusationResponse } from '../models/accusation';
import { PlayerScore } from '../models';

@Injectable({ providedIn: 'root' })
export class PlayerService {
    private playerURL = ConfigService.getApiEndpoint() + 'v1/player/';

    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }

   search(query: any, projectId: string): Observable<PlayerResponse> {
        return this.http.get<PlayerResponse>(this.playerURL + 'project/' + projectId, { params: query }).pipe(
            catchError(this.error.handleError('player.search', null))
        );
    }

    getOne(id: string, query: any): Observable<Player> {
        return this.http.get<Player>(this.playerURL + id, { params: query }).pipe(
            catchError(this.error.handleError('player.getOne', null))
        );
    }

    getSessions(id: string, query: any): Observable<SessionResponse> {
        return this.http.get<SessionResponse>(this.playerURL + id + '/sessions', { params: query }).pipe(
            catchError(this.error.handleError('player.getSessions', null))
        );
    }

    getPlayerScore(id: string, projectId: string): Observable<PlayerScore> {
        return this.http.get<PlayerScore>(this.playerURL + id + '/score', {params: {projectId: projectId}}).pipe(
            catchError(this.error.handleError('player.getPlayerScore', null))
        );
    }

    getAccusations(id: string, query: any): Observable<AccusationResponse> {
        return this.http.get<AccusationResponse>(this.playerURL + id + '/accusations', { params: query }).pipe(
            catchError(this.error.handleError('player.getAccusations', null))
        );
    }

    getPlayerProjects(id: string, query: any): Observable<ProjectResponse> {
        return this.http.get<AccusationResponse>(this.playerURL + id + '/projects', { params: query }).pipe(
            catchError(this.error.handleError('player.getProjects', null))
        );
    }

    getAccusationDownloadEvidence(playerId: string, accusationId: string): void {
        this.http.get(this.playerURL + playerId + '/accusation/' + accusationId + '/evidence', {responseType: 'blob'})
            .subscribe(blob => {
                this.downloadData(accusationId + '.zip', window.URL.createObjectURL(blob));
            },
            error => {
                this.error.handleError('download.accusation.evidence', null);
            });
    }

    /**
     * opens the saveFile dialog with the given objectUrl
     * @param name the target name of the file
     * @param objectUrl the content of the file
     */
    private downloadData(name: string, objectUrl: string) {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = objectUrl;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(objectUrl);
    }

    addLabelToPlayer(playerId: string, addLabelRequest: AddLabelRequest): Observable<Label> {
        return this.http.post<Label>(this.playerURL + playerId + '/label/', addLabelRequest).pipe(
            tap(_ => this.eventService.addAlert(`updated playerId: ${playerId}`)),
            catchError(this.error.handleError('profile.addLabelToPlayer', null))
        );

    }

    removeLableFromPlayer(playerId: string, labelId: string) {
        return this.http.delete<Label[]>(this.playerURL + playerId + '/label/' + labelId).pipe(
            catchError(this.error.handleError('profile.removeLableFromPlayer', null))
        );
    }

    getOverallAccusedPlayer(query: any) {
        return this.http.get<AccusationResponse[]>(this.playerURL + 'accusations/', { params: query }).pipe(
            catchError(this.error.handleError('profile.getOverallAccusedPlayer', null))
        );
    }
    getOnePlayerAccusation(accusationId: string, playerId: string, query: any) {
        return this.http.get<AccusationResponse[]>(this.playerURL + playerId + '/accusation/' + accusationId, { params: query }).pipe(
            catchError(this.error.handleError('profile.getOverallAccusedPlayer', null))
        );
    }



}
